import { render, staticRenderFns } from "./signature_report_official.vue?vue&type=template&id=45fb92b2&scoped=true"
import script from "./signature_report_official.vue?vue&type=script&lang=js"
export * from "./signature_report_official.vue?vue&type=script&lang=js"
import style0 from "./signature_report_official.vue?vue&type=style&index=0&id=45fb92b2&prod&scoped=true&lang=scss"
import style1 from "./signature_report_official.vue?vue&type=style&index=1&id=45fb92b2&prod&lang=scss"
import style2 from "./signature_report_official.vue?vue&type=style&index=2&id=45fb92b2&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fb92b2",
  null
  
)

export default component.exports